import _ from 'underscore';

/**
 * Compares two locations.
 * @param {Object} x - Location being compared.
 * @param {Object} y - Location being compared.
 * @returns {Boolean} - True if they are equal.
 */

const isGeoPointEqual = (x, y) => {
  if (x.GeoPoint.Longitude === y.GeoPoint.Longitude
    && x.GeoPoint.Latitude === y.GeoPoint.Latitude) {
    return true;
  }
  return false;
};

export function isLocationEqual(x, y, areRadiusLocations = false) {
  if (x.Id === y.Id) {
    // MT API: Id is set and it matches
    if (_.isFinite(x.Id)) {
      return true;
    }
    // Bing Maps API: Id is not set but longitude, latitude, and type match
    if (isGeoPointEqual(x, y) === true && x.Type === y.Type) {
      return true;
    }
  } else if (areRadiusLocations) {
    // Radius locations won't equal id but longitude, latitude and type do
    return isGeoPointEqual(x, y);
  }

  return false;
}

export function isLegacyLocationAndRadiusEqual(existingTarget, newTarget) {
  const {
    location: existingLocation,
  } = existingTarget;

  const {
    location: newLocation,
  } = newTarget;

  if ((!existingTarget.isRadiusLocationTarget && newTarget.isRadiusLocationTarget && existingTarget.targetingType === 'Excluded')
  || (!existingTarget.isRadiusLocationTarget && !newTarget.isRadiusLocationTarget)) {
    if (_.isFinite(existingLocation.Id) && existingLocation.Id === newLocation.Id) {
      return true;
    }
  }

  if (existingTarget.isRadiusLocationTarget && newTarget.isRadiusLocationTarget) {
    return isGeoPointEqual(existingLocation, newLocation)
      && existingTarget.radiusSize === newTarget.radiusSize
      && existingTarget.radiusUnit === newTarget.radiusUnit;
  }

  return false;
}
